module.exports = __webpack_public_path__ + "img/RBS04_thumb.fceb17fe.jpg";